import React, { useEffect } from 'react';
import Mapping from 'pages/mapping/mapping';
import { Routes, Route, useLocation } from 'react-router-dom';
import Page from 'pages/page';
import Password from 'pages/password/password';
import Login from 'pages/login/login';
import Cabinet from 'pages/cabinet/cabinet';
import Main from 'pages/main/main';
import Search from 'pages/search/search';
import Tags from 'pages/tags/tags';
import Card from 'pages/card/card';
import Upload from 'pages/upload/upload';
import AdminRequests from 'pages/admin/requests/requests';
import AdminExisting from 'pages/admin/existing/existing';
import RedirrectWrapper from 'components/redirrectWrapper';
import { yandexMetricsHit } from 'utils/yandexMetrics';

export default function RoutesComponent() {
  const location = useLocation();

  // Хук для Яндекс Метрики
  useEffect(() => {
    yandexMetricsHit(location.pathname);
  }, [location]);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <Page isAdminPage={false} isLoginPage={true} name="login">
            <Login />
          </Page>
        }
      />
      <Route
        path="/password"
        element={
          <Page isAdminPage={false} isLoginPage={true} name="password">
            <Password />
          </Page>
        }
      />

      {/* Админка */}
      <Route path="/admin">
        <Route
          path=""
          element={
            <RedirrectWrapper>
              <AdminRequests></AdminRequests>
            </RedirrectWrapper>
          }
        ></Route>
        <Route
          path="requests"
          element={
            <RedirrectWrapper>
              <AdminRequests></AdminRequests>
            </RedirrectWrapper>
          }
        ></Route>
        <Route
          path="existing"
          element={
            <RedirrectWrapper>
              <AdminExisting></AdminExisting>
            </RedirrectWrapper>
          }
        ></Route>
      </Route>

      <Route
        path="/cabinet"
        element={
          <RedirrectWrapper>
            <Cabinet></Cabinet>
          </RedirrectWrapper>
        }
      />
      <Route
        path="/search"
        element={
          <RedirrectWrapper>
            <Search></Search>
          </RedirrectWrapper>
        }
      />
      <Route
        path="/mapping"
        element={
          <RedirrectWrapper>
            <Mapping></Mapping>
          </RedirrectWrapper>
        }
      />
      <Route
        path="/tags"
        element={
          <RedirrectWrapper>
            <Tags></Tags>
          </RedirrectWrapper>
        }
      />
      <Route
        path="/upload"
        element={
          <RedirrectWrapper>
            <Upload></Upload>
          </RedirrectWrapper>
        }
      />
      <Route path="/card">
        <Route
          path=":cardId"
          element={
            <RedirrectWrapper>
              <Card></Card>
            </RedirrectWrapper>
          }
        ></Route>
      </Route>
      {/* Главные страницы */}
      <Route
        path="/"
        element={
          <RedirrectWrapper>
            <Main></Main>
          </RedirrectWrapper>
        }
      ></Route>

      <Route
        path="/photos"
        element={
          <RedirrectWrapper>
            <Main></Main>
          </RedirrectWrapper>
        }
      ></Route>
      <Route
        path="/illustrations"
        element={
          <RedirrectWrapper>
            <Main></Main>
          </RedirrectWrapper>
        }
      ></Route>
      <Route
        path="/vectors"
        element={
          <RedirrectWrapper>
            <Main></Main>
          </RedirrectWrapper>
        }
      ></Route>
    </Routes>
  );
}
